module.exports = {
    "id": "en",
    "label": "English",
    "rtl": false,

    "translations": {
        "INVALID_LINK_TITLE":           "Invalid Link",
        "INVALID_LINK_TEXT":            "Please use the unsubscribe link in your email to unsubscribe from our mailing lists.",
        "UNSUBSCRIBE_ARE_YOU_SURE":     "Are you sure you want to unsubscribe this email from our mailing lists?",
        "UNSUBSCRIBE_CLICK_CONFIRM":    "Click the \"Unsubscribe\" button below to confirm.",
        "YOU_HAVE_BEEN_UNSUBSCRIBED":   "You have been <b>unsubscribed</b> from our mailing lists.",
        "UNSUBSCRIBED_IN_ERROR":        "If you have unsubscribed in error, please click the <a href='/resubscribe' class='resubscribe'>resubscribe</a> link.",
        "CANCELLED_STILL_SUBSCRIBED":   "<b>Cancelled.</b> You are still <b>subscribed</b> to our mailing lists.",
        "THANK_YOU_FOR_CONTINUING":     "Thank you for continuing to participate in our surveys.",
        "EMAIL_ALREADY_UNSUBSCRIBED":   "This email is already <b>unsubscribed</b> from our mailing lists.",
        "CLICK_RESUBSCRIBE_TO_REJOIN":  "Click the \"resubscribe\" button below to rejoin our mailing lists.",
        "YOU_HAVE_BEEN_RESUBSCRIBED":   "You have been <b>resubscribed</b> to our mailing lists.",
        "YOU_ARE_ALREADY_SUBSCRIBED":   "You are already <b>subscribed</b> to our mailing lists.",
        "THANK_YOU_FOR_PARTICIPATING":  "Thank you for participating in our surveys.",
        "CHECKING":                     "Checking...",
        "UNSUBSCRIBE":                  "Unsubscribe",
        "RESUBSCRIBE":                  "Resubscribe",
        "EMAIL":                        "Email",
        "CANCEL":                       "Cancel"
    }
};

